<vb-app-header
    logoSrc="/assets/viewbid/images/logo_viewbid.svg"
    homeHref="/home"
    [navItems]="navItems"
    [activeNavId]="activeNavId"
    [signedIn]="user !== null"
    [adminHref]="isAdmin ? adminHref : ''"
    [showSearch]="false"
    [user]="headerUser"
    [watchCount]="watchCount"
    [menuItems]="menuItems"
    (logoClick)="onLogoClick($event)"
    (navSelect)="onNavSelect($event)"
    (watchlistClick)="onWatchlistClick()"
    (menuItemSelect)="onMenuItemSelect($event)"
    (signIn)="onSignIn()"
    (signOut)="onSignOut()">
    <!-- Notifications bell with its own badge, dropdown, and socket updates —
         replaces the header's built-in bell. isMobile is deliberately NOT
         bound: the legacy component blanks the badge number on mobile (the
         old header used a bare dot there), but the new header shows numeric
         badges everywhere — matching the watchlist badge beside it. -->
    <app-notifications
        *ngIf="user !== null"
        vbHeaderNotifications></app-notifications>
</vb-app-header>

<!-- Gated on a completed profile, not just a signed-in user: mid-registration
     the store user exists (Auth0 session) but there is no app JWT yet, and the
     chatbox's topics fetch is bearer-protected — the resulting 403 made the
     interceptor log out and bounce new users back to /login. -->
<vb-chatbox *ngIf="user?.['accountMappingsId']"></vb-chatbox>
